import { Component } from '@angular/core';

@Component({
  selector: 'fl-inline-success-box',
  templateUrl: './inline-success-box.component.html',
  styles: [
  ]
})
export class InlineSuccessBoxComponent {


}
